export const actions = {
  async getAll(state, data) {
    const filters = new URLSearchParams(data).toString()
    const res = await this.$axios.get('/boxes?' + filters)
    return res.data
  },
  async getOne(state, name) {
    const res = await this.$axios.get('/boxes/' + name)
    return res.data
  },
  async filters(state) {
    const res = await this.$axios.get('/boxes/filters')
    return res.data
  },
}
